import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const mediaUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${process.env.REACT_APP_BACKEND_URL}/api/media/${p}`);

export const api = {
  getConfig: () => axios.get(`${API}/site-config`).then((r) => r.data),
  getArticles: () => axios.get(`${API}/articles`).then((r) => r.data),
  getArticle: (slug) => axios.get(`${API}/articles/${slug}`).then((r) => r.data),
  getTracks: () => axios.get(`${API}/tracks`).then((r) => r.data),
  getFeaturedMedia: () => axios.get(`${API}/featured-media`).then((r) => r.data),
  getTeam: () => axios.get(`${API}/team`).then((r) => r.data),
  getShop: () => axios.get(`${API}/shop`).then((r) => r.data),
  getLatestVideo: () => axios.get(`${API}/youtube/latest`).then((r) => r.data),
  subscribe: (email, source = "site") =>
    axios.post(`${API}/newsletter`, { email, source }).then((r) => r.data),
  sendInquiry: (payload) => axios.post(`${API}/inquiries`, payload).then((r) => r.data),
};

export const BRAND_IMAGE =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_0a9e5941-b54a-4b70-964a-e798012645b5/artifacts/fb8xr1da_IMG_2297%281%29.jpeg";

export const YOUTUBE_CHANNEL = "https://www.youtube.com/@TheCobainReport";
